import loadLocaleBundle from 'Translations/loadLocaleBundle'
import loadThreeDStudioLocaleBundle from 'Translations/loadThreeDStudioLocaleBundle'

// Start fetching the active locale's translations at script-eval time so the
// bundles are registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages. The three-d-studio bundle is
// needed because SignInModalHost mounts LazyAiSignInModal, which resolves the
// three-d-studio namespace.
const localeReady = Promise.all([loadLocaleBundle(), loadThreeDStudioLocaleBundle()])

window.addEventListener("load", () => {
  localeReady.then(() => {
    const ReactRailsUJS = require("react_ujs");
    const context = require.context('Pods', true, /\/(?:AiGeneratorLanding|AiGeneratorHub)\/(?!.*(?:test|story).*$).*$/)

    ReactRailsUJS.useContext(context);
    ReactRailsUJS.mountComponents("#ai-generator-landing-elements");
  })
});
